import { render, staticRenderFns } from "./CompanyMessageForm.vue?vue&type=template&id=d540a13e&scoped=true"
import script from "./CompanyMessageForm.vue?vue&type=script&lang=js"
export * from "./CompanyMessageForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyMessageForm.vue?vue&type=style&index=0&id=d540a13e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d540a13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d540a13e')) {
      api.createRecord('d540a13e', component.options)
    } else {
      api.reload('d540a13e', component.options)
    }
    module.hot.accept("./CompanyMessageForm.vue?vue&type=template&id=d540a13e&scoped=true", function () {
      api.rerender('d540a13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/companymessage/CompanyMessageForm.vue"
export default component.exports